<template>
  <div id="home">
    <div class="main">
      <h2>{{ $t('cmsg.login')}}</h2>
      <div class="loginWrapper">
        <el-row :gutter="15">
          <el-col :span="16">
            <el-tabs v-model="activeTab">
              <el-tab-pane :label="$t('cmsg.email')" name="emailLogin">
                <emailLogin/>
              </el-tab-pane>
              <el-tab-pane :label="$t('cmsg.mobile')" name="mobileLogin">
                <phoneLogin/>
              </el-tab-pane>
            </el-tabs>
          </el-col>
          <el-col :span="8">
            <rightSide/>
          </el-col>
        </el-row>
      </div>
    </div>
    <bottomWrapper/>
  </div>
</template>

<script>
// @ is an alias to /src
import Cookies from "js-cookie";
import bottomWrapper from "@/views/component/bottom.vue";
import emailLogin from "./component/email.vue";
import phoneLogin from "./component/phone.vue";
import rightSide from "./component/rightSide.vue";
export default {
  name: "home",
  components: {
    emailLogin,
    phoneLogin,
    rightSide,
    bottomWrapper
  },
  metaInfo() {
    return {
      title: this.$gf.sysParam(this.$gf.lang(), 'title') + "-" + this.$t("cmsg.login"),
      meta: [
        { vmid: "description", name: "description", content: "Shining3D Login" }
      ]
    };
  },
  data() {
    return {
      activeTab: "emailLogin"
    };
  },
  watch: {
    activeTab: function(n, o) {
      console.log("n: ", n);
      console.log("o: ", o);
      Cookies.set("activeTab", n, {expires: 36500});
    }
  },
  mounted() {
    // console.log(pub.cdnUrl);
    var cActiveTab = Cookies.get("activeTab");
    if(!cActiveTab) {
      Cookies.set("activeTab", this.activeTab, {expires: 36500});
    } else {
      this.activeTab = cActiveTab;
    }
    var cUN = Cookies.get("un");
    if(cUN && cUN.indexOf('@')>-1){
      this.activeTab = 'emailLogin';
      Cookies.set("activeTab", this.activeTab, {expires: 36500});
    }
    if(cUN && cUN.indexOf('@')<0){
      this.activeTab = 'mobileLogin';
      Cookies.set("activeTab", this.activeTab, {expires: 36500});
    }
    console.log("mounted:",pub.cdnUrl);
  // },
  // async asyncData(context) {
  //   var u = {};
  //   if(process.server) {
  //   // console.log(context.req.cookies);
  //     u["un"] = context.req.cookies.un;
  //     u["upa"] = context.req.cookies.upa;
  //     u["ult"] = context.req.cookies.ult;
  //   } else {
  //     u["un"] = Cookies.get("un");
  //     u["upa"] = Cookies.get("upa");
  //     u["ult"] = Cookies.get("ult");
  //   }
  //   await context.$axios
  //     .post("/api/fetchRPwd", u,{
  //       json: true,
  //       validateStatus: function(status) {
  //         return status >= 200 && status < 404; // default
  //       }
  //     }).then(res=>{
  //       console.log(res.data);
  //       if(res.data && res.data.status==="success" && res.data.result !== "") {
  //         context.app.$EventBus.$emit("dpwd", res.data.result);
  //       }
  //     }).catch(e=>{
  //       console.log(e);
  //     });
  }
};
</script>
<style lang="scss">
#home {
  .main {
    background-color: #f7f9fb;
    padding: 15px 0px;
    h2 {
      // min-width: 1200px;
      width: 65vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      text-align: left;
      margin: 0 auto;
      border-bottom: 5px solid #4b91d1;
      margin-bottom: 15px;
      padding-bottom: 5px;
    }
    .loginWrapper {
      // min-width: 1200px;
      width: 65vw;
      @media only screen and (max-width: 1020px) {
        width: 95vw;
      }
      margin: 0 auto;
    }
  }
}
</style>
